module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('TopNavFooter', [_c('div', {
    staticClass: "main-content",
    attrs: {
      "id": "admin"
    }
  }, [_c('spinner', {
    attrs: {
      "spinnerOn": _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid",
    staticStyle: {
      "background": "#fff",
      "padding": "0px",
      "padding-top": "35px"
    }
  }, [_c('div', {
    staticClass: "modal deleteConfirmModal",
    attrs: {
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "color": "#00524A"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "col-lg-9 col-md-9 col-sm-9 col-xs-9",
    staticStyle: {
      "font-weight": "bold",
      "float": "left",
      "width": "90%"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.delete))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    staticStyle: {
      "background": "#ffffff !important",
      "color": "#000 !important"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "font-size": "18px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticStyle: {
      "margin-right": "233px",
      "width": "100%",
      "text-align": "left"
    }
  }, [_c('label', {
    staticClass: "form-control-label col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "font-size": "18px",
      "font-weight": "normal !important"
    },
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.wanttodeleteadminconfig) + " ")])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.removeConfirm()
      }
    }
  }, [_vm._v(_vm._s(_vm.user_lang.yes))]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "href": "#",
      "data-dismiss": "modal"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.no))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal cannotDeleteModal",
    attrs: {
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "color": "#00524A"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "display": "block",
      "border": "0px !important"
    }
  }, [_c('div', {
    staticClass: "col-lg-9 col-md-9 col-sm-9 col-xs-9",
    staticStyle: {
      "float": "left",
      "width": "90%",
      "margin": "10px"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.cannotdeleteconfig))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    staticStyle: {
      "background": "#ffffff !important",
      "color": "#000 !important"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "font-size": "18px"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticStyle: {
      "margin": "-15px"
    }
  }, [_c('div', {
    staticClass: "bc-adduser"
  }, [_c('div', {
    staticStyle: {
      "font-size": "44px !important",
      "font-weight": "bold",
      "overflow": "auto",
      "margin-bottom": "15px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.user_lang.tmlabel))])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "14px",
      "margin": "10px 0px"
    }
  }, [_vm._v("\n\t            Note: Ensure that the configured groups are as allowed by the access rules and the service account permissions set in the Okta admin console.\n              "), _c('div', [_vm._v("Internal User groups should not be configured to be managed by this application.")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAppList),
      expression: "showAppList"
    }]
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "10px 10px"
    }
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('input', {
    staticClass: "form-control search-app",
    attrs: {
      "placeholder": "Search Application",
      "type": "text",
      "id": "search-criteria"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-search"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-6",
    staticStyle: {
      "text-align": "right",
      "padding": "10px"
    }
  }, [_c('button', {
    staticStyle: {
      "margin-right": "15px",
      "line-height": "16px",
      "cursor": "pointer",
      "border-radius": "2px"
    },
    on: {
      "click": function($event) {
        _vm.addConfigRow();
        _vm.changeToAppView()
      }
    }
  }, [_vm._v("Add New App")])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "border": "1px solid #000",
      "background": "#213031",
      "padding": "10px 10px"
    }
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "color": "#fff",
      "font-weight": "bold"
    }
  }, [_vm._v("Applications")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-4 col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "color": "#fff",
      "font-weight": "bold"
    }
  }, [_vm._v("Brand")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2 col-md-2 col-sm-2 col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "color": "#fff",
      "font-weight": "bold"
    }
  }, [_vm._v("Action")])])]), _vm._v(" "), _vm._l((_vm.appNameList), function(x, index) {
    return _c('div', {
      key: x.id + '~' + index,
      staticClass: "row searchbox",
      staticStyle: {
        "padding": "5px 10px",
        "border-bottom": "8px solid #eceff1",
        "background-color": "#FFFFFF"
      }
    }, [_c('div', {
      staticClass: "col-lg-6 col-md-6 col-sm-6 col-xs-12",
      class: {
        disabled: x.label.indexOf('Deleted App') > -1
      }
    }, [_c('div', {
      staticClass: "app-name list",
      on: {
        "click": function($event) {
          _vm.getApplicationGroups(_vm.appAdminGroupModal[index].applicationId, index);
        }
      }
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_vm._v(_vm._s(x.label))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-4 col-md-4 col-sm-4 col-xs-12"
    }, [_c('div', {
      staticClass: "app-name",
      staticStyle: {
        "pointer-events": "none",
        "text-transform": "capitalize"
      }
    }, [_vm._v(_vm._s(_vm.appAdminGroupModal[index].brand))])]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-2 col-md-2 col-sm-2 col-xs-12"
    }, [_c('button', {
      staticClass: "deleteconfig",
      on: {
        "click": function($event) {
          _vm.removeRow(_vm.appAdminGroupModal[index].appGrpId, index, _vm.appAdminGroupModal[index].applicationId)
        }
      }
    }, [_vm._v("Delete")])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.deleteSuccess),
      expression: "deleteSuccess"
    }],
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin": "15px",
      "color": "green"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.adminconfigdeletesuccess))])])], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showAppList),
      expression: "!showAppList"
    }]
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('div', {
    staticClass: "appDetails",
    staticStyle: {
      "font-size": "20px",
      "font-weight": "bolder",
      "padding-left": "5px"
    }
  }, [_vm._v("App Configuration")])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "appDetails"
  }, [_vm._v("Application")]), _vm._v(" "), _c('span', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.appAdminGroupModal[_vm.applicationIndex].applicationId),
      expression: "appAdminGroupModal[applicationIndex].applicationId"
    }],
    staticClass: "dropdownWrap",
    class: {
      disabledLight: _vm.appAdminGroupModal[_vm.applicationIndex].applicationId !== undefined &&
        _vm.appAdminGroupModal[_vm.applicationIndex].applicationId !== 'undefined' && _vm.appAdminGroupModal[_vm.applicationIndex].groupId !== 'undefined'
    },
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": 'select' + _vm.appAdminGroupModal[_vm.applicationIndex].applicationId
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.appAdminGroupModal[_vm.applicationIndex].applicationId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getGroups(_vm.appAdminGroupModal[_vm.applicationIndex].applicationId)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "undefined"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.selectapp))]), _vm._v(" "), _vm._l((_vm.appList), function(j) {
    return (j.name !== 'bookmark') ? _c('option', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.appAdminGroupModal[_vm.applicationIndex].appGrpId === undefined),
        expression: "appAdminGroupModal[applicationIndex].appGrpId === undefined"
      }],
      key: j.id,
      domProps: {
        "value": j.id
      }
    }, [_vm._v(_vm._s(j.label))]) : _vm._e()
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "appDetails"
  }, [_vm._v("Brand")]), _vm._v(" "), _c('span', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.appAdminGroupModal[_vm.applicationIndex].brand),
      expression: "appAdminGroupModal[applicationIndex].brand"
    }],
    staticClass: "dropdownWrap",
    class: {
      disabledLight: _vm.appAdminGroupModal[_vm.applicationIndex].appGrpId !== undefined &&
        _vm.appAdminGroupModal[_vm.applicationIndex].appGrpId !== ''
    },
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": 'selectbrand' + _vm.appAdminGroupModal[_vm.applicationIndex].applicationId
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.appAdminGroupModal[_vm.applicationIndex].brand = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "undefined"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.selectBrand))]), _vm._v(" "), _vm._l((_vm.brandDetails.data), function(j) {
    return _c('option', {
      key: j.brandKey,
      domProps: {
        "value": j.brandKey
      }
    }, [_vm._v(_vm._s(j.brandName))])
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "appDetails"
  }, [_vm._v(_vm._s(_vm.user_lang.admingroup))]), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.groupNameTyped),
      expression: "groupNameTyped"
    }],
    class: {
      disabledLight: _vm.appAdminGroupModal[_vm.applicationIndex].appGrpId !== undefined && _vm.appAdminGroupModal[_vm.applicationIndex].appGrpId !== ''
    },
    staticStyle: {
      "height": "40px !important",
      "width": "75%",
      "font-size": "16px !important"
    },
    attrs: {
      "type": "text",
      "tabindex": "-1",
      "placeholder": "Search group name"
    },
    domProps: {
      "value": (_vm.groupNameTyped)
    },
    on: {
      "keydown": function($event) {
        _vm.onSearch()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.groupNameTyped = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "75%"
    },
    attrs: {
      "id": "dropdown"
    }
  }, [(_vm.isSearched && _vm.groupNameTyped.length > 0) ? _c('div', {
    staticClass: "searchDropDown"
  }, [_vm._l((_vm.searchDropdownData), function(j) {
    return _c('div', {
      key: j.id
    }, [_c('div', {
      staticClass: "search-list-for-admin",
      attrs: {
        "for": j.id
      },
      on: {
        "click": function($event) {
          _vm.selectAdminGroupFromList(j)
        }
      }
    }, [_vm._v(_vm._s(j.profile.name))])])
  }), _vm._v(" "), (_vm.searchDropdownData.length === 0) ? _c('div', [_c('i', [_vm._v("No groups found.")])]) : _vm._e()], 2) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "appDetails"
  }, [_vm._v(_vm._s(_vm.user_lang.administeredgroups))]), _vm._v(" "), _c('span', [_c('div', {
    staticStyle: {
      "width": "75%"
    },
    attrs: {
      "id": "dropdown"
    }
  }, [_c('div', {
    staticClass: "selectDropDown",
    on: {
      "click": function($event) {
        _vm.openDropDown(_vm.applicationIndex)
      }
    }
  }, [_c('span', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "margin-top": "5px",
      "padding-left": "10px"
    }
  }, [(_vm.appAdminGroupModal[_vm.applicationIndex].subGroupId && _vm.appAdminGroupModal[_vm.applicationIndex].subGroupId.length == 0) ? _c('span', [_vm._v("\n\t\t\t                      " + _vm._s(_vm.user_lang['selectgroupslist']) + " \n                          ")]) : _vm._e(), _vm._v(" "), (_vm.appAdminGroupModal[_vm.applicationIndex].subGroupId && _vm.appAdminGroupModal[_vm.applicationIndex].subGroupId.length > 0) ? _c('span', [_vm._v("\n  \t\t\t                    Selected (" + _vm._s(_vm.appAdminGroupModal[_vm.applicationIndex].subGroupId ? _vm.appAdminGroupModal[_vm.applicationIndex].subGroupId.length : '0') + ")\n                          ")]) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "fa fa-caret-down",
    staticStyle: {
      "float": "right",
      "margin": "4px 5px"
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDropdownForGroups),
      expression: "showDropdownForGroups"
    }],
    class: 'ddwrap' + _vm.applicationIndex,
    attrs: {
      "id": "checkboxlist"
    }
  }, [_vm._l((_vm.currGroupDetails), function(j) {
    return _c('div', {
      key: j.id,
      staticClass: "dd-list-item",
      staticStyle: {
        "padding-right": "15px",
        "padding-left": "5px"
      }
    }, [_c('input', {
      staticClass: "form-control input-checkbx-sub",
      attrs: {
        "id": j.id + '~' + _vm.applicationIndex,
        "type": "checkbox"
      },
      domProps: {
        "value": j._embedded.group.profile.name
      },
      on: {
        "change": function($event) {
          _vm.checkchange($event)
        }
      }
    }), _vm._v(" "), _c('label', {
      staticStyle: {
        "vertical-align": "super"
      },
      attrs: {
        "for": j.id
      }
    }, [_vm._v(_vm._s(j._embedded.group.profile.name))])])
  }), _vm._v(" "), _vm._l((_vm.appAdminGroupModal[_vm.applicationIndex].subGroupId), function(j) {
    return (j.indexOf('~~~') > -1 && !_vm.currGroupDetails.some(function (x) { return x.id.indexOf(j.id) > -1; })) ? _c('div', {
      key: j.id,
      staticClass: "dd-list-item",
      staticStyle: {
        "padding-right": "15px",
        "padding-left": "5px"
      }
    }, [_c('input', {
      staticClass: "form-control input-checkbx-sub",
      attrs: {
        "id": j.split('~~~')[0] + '~' + _vm.applicationIndex,
        "type": "checkbox"
      },
      domProps: {
        "value": j.split('~~~')[1]
      },
      on: {
        "change": function($event) {
          _vm.checkchange($event)
        }
      }
    }), _vm._v(" "), _c('label', {
      staticStyle: {
        "vertical-align": "super"
      },
      attrs: {
        "for": j.split('~~~')[0]
      }
    }, [_vm._v(_vm._s(j.split('~~~')[1]))])]) : _vm._e()
  })], 2)]), _vm._v(" "), (_vm.appAdminGroupModal[_vm.applicationIndex].subGroupId.length > 0) ? _c('div', {
    staticStyle: {
      "text-align": "right",
      "color": "#658d1b",
      "font-weight": "600"
    }
  }, [_vm._v(" Read Only ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.appAdminGroupModal[_vm.applicationIndex].subGroupManagement), function(j) {
    return _c('span', {
      key: j.subGroupId,
      staticStyle: {
        "display": "block",
        "padding": "5px"
      }
    }, [(!j.roleChanged) ? _c('span', [_vm._v(_vm._s(j.subGroupName) + "\n                        "), _c('label', {
      staticClass: "switch",
      staticStyle: {
        "float": "right"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (j.isReadOnly),
        expression: "j.isReadOnly"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(j.isReadOnly) ? _vm._i(j.isReadOnly, null) > -1 : (j.isReadOnly)
      },
      on: {
        "__c": function($event) {
          var $$a = j.isReadOnly,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (j.isReadOnly = $$a.concat([$$v]))
            } else {
              $$i > -1 && (j.isReadOnly = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            j.isReadOnly = $$c
          }
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "slider round"
    })])]) : (j.roleChanged) ? _c('span', [_vm._v(_vm._s(j.subGroupName) + "\n                        "), _c('i', {
      staticClass: "fa fa-remove-circle"
    })]) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-weight": "600",
      "margin-top": "5px"
    }
  }, [_vm._v("Administer additional group:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.additionalGroup[_vm.applicationIndex]),
      expression: "additionalGroup[applicationIndex]"
    }],
    staticClass: "addgrouptxtbox",
    attrs: {
      "type": "text",
      "placeholder": "Enter group name and click +"
    },
    domProps: {
      "value": (_vm.additionalGroup[_vm.applicationIndex])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.additionalGroup, _vm.applicationIndex, $event.target.value)
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-plus-circle",
    staticStyle: {
      "font-size": "20px",
      "cursor": "pointer",
      "color": "rgb(101, 141, 27)",
      "margin-left": "10px"
    },
    on: {
      "click": function($event) {
        _vm.addAdditionalGroup(_vm.applicationIndex, _vm.appAdminGroupModal[_vm.applicationIndex].applicationId)
      }
    }
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "appDetails"
  }, [_vm._v(_vm._s(_vm.user_lang.isDxpApp))]), _vm._v(" "), _c('label', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.appAdminGroupModal[_vm.applicationIndex].isDxp),
      expression: "appAdminGroupModal[applicationIndex].isDxp"
    }],
    staticStyle: {
      "width": "25px",
      "vertical-align": "middle"
    },
    attrs: {
      "id": 'select' + _vm.appAdminGroupModal[_vm.applicationIndex].applicationId,
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.appAdminGroupModal[_vm.applicationIndex].isDxp) ? _vm._i(_vm.appAdminGroupModal[_vm.applicationIndex].isDxp, null) > -1 : (_vm.appAdminGroupModal[_vm.applicationIndex].isDxp)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.appAdminGroupModal[_vm.applicationIndex].isDxp,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.appAdminGroupModal[_vm.applicationIndex].isDxp = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.appAdminGroupModal[_vm.applicationIndex].isDxp = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.appAdminGroupModal[_vm.applicationIndex].isDxp = $$c
        }
      }
    }
  }), _vm._v("\n                    " + _vm._s(_vm.user_lang.dxpActivation) + "\n                  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('div', {
    staticClass: "appDetails",
    staticStyle: {
      "font-size": "20px",
      "font-weight": "bolder",
      "padding-left": "5px"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.selfRegistration))])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12",
    staticStyle: {
      "padding-top": "15px"
    }
  }, [_c('div', [_c('label', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.appAdminGroupModal[_vm.applicationIndex].isSelfReg),
      expression: "appAdminGroupModal[applicationIndex].isSelfReg"
    }],
    staticStyle: {
      "width": "25px",
      "vertical-align": "middle"
    },
    attrs: {
      "id": 'chkSelf' + _vm.appAdminGroupModal[_vm.applicationIndex].applicationId,
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.appAdminGroupModal[_vm.applicationIndex].isSelfReg) ? _vm._i(_vm.appAdminGroupModal[_vm.applicationIndex].isSelfReg, null) > -1 : (_vm.appAdminGroupModal[_vm.applicationIndex].isSelfReg)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.appAdminGroupModal[_vm.applicationIndex].isSelfReg,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.appAdminGroupModal[_vm.applicationIndex].isSelfReg = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.appAdminGroupModal[_vm.applicationIndex].isSelfReg = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.appAdminGroupModal[_vm.applicationIndex].isSelfReg = $$c
        }
      }
    }
  }), _vm._v("\n                      " + _vm._s(_vm.user_lang.selfRegistration) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('label', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.appAdminGroupModal[_vm.applicationIndex].disableExistingUserOnboard),
      expression: "appAdminGroupModal[applicationIndex].disableExistingUserOnboard"
    }],
    class: {
      disabledLight: !_vm.appAdminGroupModal[_vm.applicationIndex].isSelfReg
    },
    staticStyle: {
      "width": "25px",
      "vertical-align": "middle"
    },
    attrs: {
      "id": 'chkDisableExistingUserOnboard' + _vm.appAdminGroupModal[_vm.applicationIndex].applicationId,
      "type": "checkbox",
      "disabled": !_vm.appAdminGroupModal[_vm.applicationIndex].isSelfReg
    },
    domProps: {
      "checked": Array.isArray(_vm.appAdminGroupModal[_vm.applicationIndex].disableExistingUserOnboard) ? _vm._i(_vm.appAdminGroupModal[_vm.applicationIndex].disableExistingUserOnboard, null) > -1 : (_vm.appAdminGroupModal[_vm.applicationIndex].disableExistingUserOnboard)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.appAdminGroupModal[_vm.applicationIndex].disableExistingUserOnboard,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.appAdminGroupModal[_vm.applicationIndex].disableExistingUserOnboard = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.appAdminGroupModal[_vm.applicationIndex].disableExistingUserOnboard = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.appAdminGroupModal[_vm.applicationIndex].disableExistingUserOnboard = $$c
        }
      }
    }
  }), _vm._v("\n                      " + _vm._s(_vm.user_lang.disableExistingUserOnboard) + "\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "appDetails"
  }, [_vm._v(_vm._s(_vm.user_lang.selfRegistrationEmailId))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.appAdminGroupModal[_vm.applicationIndex].emailId),
      expression: "appAdminGroupModal[applicationIndex].emailId"
    }],
    staticClass: "addgrouptxtbox",
    staticStyle: {
      "vertical-align": "middle",
      "height": "40px !important",
      "font-size": "16px !important"
    },
    attrs: {
      "id": 'txtEmail' + _vm.appAdminGroupModal[_vm.applicationIndex].applicationId,
      "type": "text"
    },
    domProps: {
      "value": (_vm.appAdminGroupModal[_vm.applicationIndex].emailId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.appAdminGroupModal[_vm.applicationIndex].emailId = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "appDetails"
  }, [_vm._v(_vm._s(_vm.user_lang.selfApp))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.appAdminGroupModal[_vm.applicationIndex].selfRegGroupId),
      expression: "appAdminGroupModal[applicationIndex].selfRegGroupId"
    }],
    staticClass: "dropdownWrap",
    class: {
      disabledLight: _vm.appAdminGroupModal[_vm.applicationIndex].isSelfRegModal || !_vm.appAdminGroupModal[_vm.applicationIndex].isSelfReg
    },
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": 'selRegGroup' + _vm.appAdminGroupModal[_vm.applicationIndex].applicationId
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.appAdminGroupModal[_vm.applicationIndex].selfRegGroupId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.populateOptionDetails(_vm.appAdminGroupModal[_vm.applicationIndex].applicationId, _vm.applicationIndex)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "undefined"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.selectReggroup))]), _vm._v(" "), _vm._l((_vm.appsSelfGroups[_vm.appAdminGroupModal[_vm.applicationIndex].applicationId]), function(j) {
    return _c('option', {
      key: j.id,
      domProps: {
        "value": j.id
      }
    }, [_vm._v(_vm._s(j._embedded.group.profile.name))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "appDetails"
  }, [_vm._v(_vm._s(_vm.user_lang.selfRegGrp))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "75%"
    },
    attrs: {
      "id": "dropdown"
    }
  }, [_c('div', {
    staticClass: "selectDropDown",
    class: {
      disabledLight: !_vm.appAdminGroupModal[_vm.applicationIndex].isSelfReg
    },
    on: {
      "click": function($event) {
        _vm.openSelfRegDropDown(_vm.applicationIndex)
      }
    }
  }, [_c('span', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "margin-top": "5px",
      "padding-left": "10px"
    }
  }, [(!_vm.appAdminGroupModal[_vm.applicationIndex].selfRegGroupList || (_vm.appAdminGroupModal[_vm.applicationIndex].selfRegGroupList && _vm.appAdminGroupModal[_vm.applicationIndex].selfRegGroupList.length == 0)) ? _c('span', [_vm._v("\n\t\t\t                    " + _vm._s(_vm.user_lang['selectgroupslist']) + " \n                        ")]) : _vm._e(), _vm._v(" "), (_vm.appAdminGroupModal[_vm.applicationIndex].selfRegGroupList && _vm.appAdminGroupModal[_vm.applicationIndex].selfRegGroupList.length > 0) ? _c('span', [_vm._v("\n\t\t\t                    Selected (" + _vm._s(_vm.appAdminGroupModal[_vm.applicationIndex].selfRegGroupList ? _vm.appAdminGroupModal[_vm.applicationIndex].selfRegGroupList.length : '0') + ")\n                        ")]) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "fa fa-caret-down",
    staticStyle: {
      "float": "right",
      "margin": "4px 5px"
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDropdownForSelfGroups),
      expression: "showDropdownForSelfGroups"
    }],
    class: 'ddwrapself' + _vm.applicationIndex,
    attrs: {
      "id": "checkboxlist"
    }
  }, [_vm._l((_vm.appsSelfGroups[_vm.appAdminGroupModal[_vm.applicationIndex].applicationId]), function(j) {
    return _c('div', {
      key: j.id,
      staticClass: "dd-list-item",
      staticStyle: {
        "padding-right": "15px",
        "padding-left": "5px"
      }
    }, [_c('input', {
      staticClass: "form-control input-checkbx-sub",
      attrs: {
        "id": j.id + '~self' + _vm.applicationIndex,
        "type": "checkbox"
      },
      domProps: {
        "value": j.id
      },
      on: {
        "change": function($event) {
          _vm.checkSelfchange($event)
        }
      }
    }), _vm._v(" "), _c('label', {
      staticStyle: {
        "vertical-align": "super"
      },
      attrs: {
        "for": j.id
      }
    }, [_vm._v(_vm._s(j._embedded.group.profile.name))])])
  }), _vm._v(" "), _vm._l((_vm.appAdminGroupModal[_vm.applicationIndex].selfRegGroupList), function(j) {
    return (j.indexOf('~~~') > -1 && _vm.appGroupsArrayMap[_vm.appAdminGroupModal[_vm.applicationIndex].applicationId] && _vm.appGroupsArrayMap[_vm.appAdminGroupModal[_vm.applicationIndex].applicationId].indexOf(j.split('~~~')[0]) === -1) ? _c('div', {
      key: j.id,
      staticClass: "dd-list-item",
      staticStyle: {
        "padding-right": "15px",
        "padding-left": "5px"
      }
    }, [_c('input', {
      staticClass: "form-control input-checkbx-sub",
      attrs: {
        "id": j.split('~~~')[0] + '~self' + _vm.applicationIndex,
        "type": "checkbox"
      },
      domProps: {
        "value": j.split('~~~')[0]
      },
      on: {
        "change": function($event) {
          _vm.checkSelfchange($event)
        }
      }
    }), _vm._v(" "), _c('label', {
      staticStyle: {
        "vertical-align": "super"
      },
      attrs: {
        "for": j.split('~~~')[0]
      }
    }, [_vm._v(_vm._s(j.split('~~~')[1]))])]) : _vm._e()
  })], 2)]), _vm._v(" "), _vm._l((_vm.appsSelfGroups[_vm.appAdminGroupModal[_vm.applicationIndex].applicationId]), function(j) {
    return (_vm.appAdminGroupModal[_vm.applicationIndex].selfRegGroupList && _vm.appAdminGroupModal[_vm.applicationIndex].selfRegGroupList.indexOf(j.id) > -1) ? _c('span', {
      key: j.id,
      staticStyle: {
        "display": "block",
        "padding": "5px"
      }
    }, [_vm._v("-" + _vm._s(j._embedded.group.profile.name))]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.appAdminGroupModal[_vm.applicationIndex].selfRegGroupList), function(j) {
    return (j.indexOf('~~~') > -1 && _vm.appGroupsArrayMap[_vm.appAdminGroupModal[_vm.applicationIndex].applicationId] && _vm.appGroupsArrayMap[_vm.appAdminGroupModal[_vm.applicationIndex].applicationId].indexOf(j.split('~~~')[0]) === -1) ? _c('span', {
      key: j.id,
      staticStyle: {
        "display": "block",
        "padding": "5px"
      }
    }, [_vm._v("-" + _vm._s(j.split('~~~')[1]))]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-weight": "600",
      "margin-top": "5px"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.selfRegSubGrps))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.additionalSelfGroup[_vm.applicationIndex]),
      expression: "additionalSelfGroup[applicationIndex]"
    }],
    staticClass: "addgrouptxtbox",
    class: {
      disabledLight: !_vm.appAdminGroupModal[_vm.applicationIndex].isSelfReg
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter group name and click +"
    },
    domProps: {
      "value": (_vm.additionalSelfGroup[_vm.applicationIndex])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.additionalSelfGroup, _vm.applicationIndex, $event.target.value)
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-plus-circle",
    staticStyle: {
      "font-size": "20px",
      "cursor": "pointer",
      "color": "rgb(101, 141, 27)",
      "margin-left": "10px"
    },
    on: {
      "click": function($event) {
        _vm.addAdditionalSelfGroup(_vm.applicationIndex, _vm.appAdminGroupModal[_vm.applicationIndex].applicationId)
      }
    }
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "appDetails"
  }, [_vm._v(_vm._s(_vm.user_lang.maxNoUsers))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.appAdminGroupModal[_vm.applicationIndex].maxSelfRegCount),
      expression: "appAdminGroupModal[applicationIndex].maxSelfRegCount"
    }],
    class: {
      disabledLight: !_vm.appAdminGroupModal[_vm.applicationIndex].isSelfReg
    },
    staticStyle: {
      "width": "75px",
      "vertical-align": "middle",
      "height": "40px !important",
      "font-size": "16px !important"
    },
    attrs: {
      "id": 'txtSelf' + _vm.appAdminGroupModal[_vm.applicationIndex].applicationId,
      "type": "text"
    },
    domProps: {
      "value": (_vm.appAdminGroupModal[_vm.applicationIndex].maxSelfRegCount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.appAdminGroupModal[_vm.applicationIndex].maxSelfRegCount = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isIncomplete),
      expression: "isIncomplete"
    }],
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin": "15px",
      "color": "red"
    }
  }, [_vm._v("\n\t              " + _vm._s(_vm.user_lang.adminConfigIncomplete))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.saveSuccess),
      expression: "saveSuccess"
    }],
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin": "15px",
      "color": "green"
    }
  }, [_vm._v("\n\t              " + _vm._s(_vm.user_lang.adminconfigupdatesuccess))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticStyle: {
      "margin-right": "15px",
      "line-height": "16px",
      "cursor": "pointer",
      "font-size": "17px",
      "border-radius": "2px"
    },
    on: {
      "click": function($event) {
        _vm.changeView()
      }
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('button', {
    staticStyle: {
      "margin-right": "15px",
      "line-height": "16px",
      "cursor": "pointer",
      "font-size": "17px",
      "border-radius": "2px"
    },
    on: {
      "click": function($event) {
        _vm.saveAdminGroups()
      }
    }
  }, [_vm._v(_vm._s(_vm.user_lang.save))])])])])])])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-47e688b5", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47e688b5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/TokenManager.vue
// module id = 711
// module chunks = 1